export const SUBSECTION_TEMPLATES = [
  {
    category: "Julkisivut",
    ptsName: "Ulkoseinät",
    imageCategory: "Julkisivut kuntoarvio",
    sectionKeywords: ["julkisivu"],
    suggestions: [],
    autoPopulate: true,
    useSectionTemplate: true,
  },
  {
    category: "Ikkunat",
    ptsName: "Ikkunat",
    imageCategory: "Ikkunat kuntoarvio",
    sectionKeywords: ["ikkunat"],
    suggestions: [],
    useSectionTemplate: true,
  },
  {
    category: "Ovet",
    ptsName: "Ulko-ovet",
    imageCategory: "Ovet kuntoarvio",
    sectionKeywords: ["ulko-ovet", "parvekeovet", "ovet"],
    suggestions: [],
    useSectionTemplate: true,
  },
  {
    category: "Parvekkeet",
    ptsName: "Parvekkeet",
    imageCategory: "Parvekkeet kuntoarvio",
    sectionKeywords: ["parveke"],
    suggestions: [],
    useSectionTemplate: true,
  },
{
  category: "Vesikatot",
  templateKey: "vesikatot",
  ptsName: "Kattorakenteet",
  imageCategory: "Vesikatot kuntoarvio",

  sectionKeywords: [
    "vesikatto",
    "vesikatot",
    "kattorakenteet",
  ],

  suggestions: [
    "Vesikaton kunto",
    "Kattorakenteet"
  ],

  useSectionTemplate: true,
},

  
{
  category: "Ryömintätilat",
  templateKey: "ryomintatilat",
  ptsName: "Alapohja",
  imageCategory: "Ryömintätilat kuntoarvio",

  sectionKeywords: [
    "ryömintätila",
    "ryömintätilat",
    "alapohja",
    "alapohjat",
  ],

  suggestions: [
    "Asuntojen alapohjat ja ryömintätilat",
  ],

  useSectionTemplate: true,
},
];
